<ul class="navbar-nav ms-auto navbar-nav-right">
  <li>
    <div class="d-flex align-items-center bg-gray-200 py-0 px-3 nav-contactInfo" style="border-radius: 10px;">
      <div class="me-3">
        <img *ngIf="!unableToLoadOrderHandlerImage" [src]="imageFilePath" style="border-radius: 50px; height:60px " [alt]="fullNameInitialOrderHandler">
        <div *ngIf="unableToLoadOrderHandlerImage">
          <span class="header-orderHandler-initial">{{fullNameInitialOrderHandler}}</span>
        </div>
      </div>
      <div class="h6 pt-2">
        <div class="fontSize-small" style="font-size:small;font-weight:bolder">If any issues, don't hesitate to contact me </div>
        <div class="fontSize-small" style="font-size:small">{{displayOrderHandlerName}} </div>
        <div class="fontSize-small" style="font-size:small">{{displayOrderHandlerEmail}} </div>
        <div class="fontSize-small" style="font-size:small">{{displayOrderHandlerContactNumber}} </div>
      </div>
    </div>

  </li>
  <li class="li-items-right" >
    <div>
      <img id="main-logo" src="{{logoPath}}" alt="" class="ShipManagerlogo" />
    </div>
  </li>

  <!-- Online/Offline -->

  <li class="li-items-right" *ngIf="onlineOfflineService.isOnline">
    <div title="Online" placement="auto" class="text-white" (click)="workOffline()" role="button">
      <i class="icon feather icon-wifi rounded-circle bg-success p-2"></i>
    </div>
  </li>
  <li class="li-items-right" *ngIf="!onlineOfflineService.isOnline">
    <div title="Offline" placement="auto" class="text-white" (click)="workOffline()" role="button">
      <i class="icon feather icon-wifi-off rounded-circle bg-danger p-2"></i>
    </div>
  </li>

  <!-- Refresh Notifications-->
  <li class="li-items-right">
    <div title="Refresh Notifications" class="dropdown" ngbDropdown placement="auto" (click)="refresh()">
      <a ngbDropdownToggle href="javascript:" data-toggle="dropdown"><i class="icon feather icon-refresh-cw" style="background-color:white;"></i></a>
    </div>
  </li>

  <!-- Notifications -->
  <li class="li-items-right">
    <div class="dropdown" ngbDropdown placement="auto">

      <div class="spinner-border spinner-border-sm text-primary" [hidden]="isDataReady" role="status"></div>
      <a ngbDropdownToggle href="javascript:" [hidden]="!isDataReady" data-toggle="dropdown"><i class="icon feather icon-bell" style="background-color:white;"></i></a>
      <span [hidden]="notificationCount==0" class="notification-counter">{{notificationCount}}</span>

      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end notification">
        <div class="noti-head">
          <h6 class="d-inline-block mb-0">Notifications</h6>
        </div>

        <div class="noti-body">
          <!--<perfect-scrollbar [style.max-height]="'100%'">-->
          <ng-scrollbar [style.max-height]="'100%'">
            <div class="col-sm-12">
              <div class="row" *ngFor="let item of userNotificationList" style="padding: 5px 0px 5px 0px;">
                <div class="col-sm-1" style="padding-top:2px;">
                  <span [title]="item.userNotificationTypeDesc" class="notification-icon {{item.userNotificationTypeIconColor}}" [ngClass]="item.userNotificationTypeIcon"></span>
                </div>
                <div class="col-sm-10" role="button" (click)="onRespondNotification(item)" style="padding-top:3px">{{item.message}}</div>
                <div class="col-sm-1" style="padding:2px 0px;">
                  <span title="Delete" class="custom-icon icon-only feather icon-trash-2" (click)="onDeleteNotification(item)"></span>
                </div>
              </div>
            </div>
          </ng-scrollbar>
          <!--</perfect-scrollbar>-->
        </div>
        <!--<div class="noti-footer">
          <a href="javascript:">show all</a>
        </div>-->
      </div>
    </div>
  </li>

  <!-- Chat -->
  <li class="li-items-right">
    <div title="IVI Assistant" class="assist-div" (click)="navToggleChat()">
      <img class="assist-icon" width="30" src="../../../../../../assets/icons/assist_icon_blue_1.svg">
    </div>
  </li>

  <!-- User -->
  <li class="li-items-right">
    <div class="dropdown drp-user ms-3" ngbDropdown placement="auto">
      <a href="javascript:" ngbDropdownToggle data-toggle="dropdown">
        <i class="icon feather icon-user" style="background-color:white;"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-end profile-notification" ngbDropdownMenu>
        <div class="pro-head">
          <img *ngIf="!unableToLoadImage" class="header-user-initial" [src]="displayPictureFilePath" (error)="onImageError($event)" [alt]="fullNameInitial">
          <span *ngIf="unableToLoadImage" class="header-user-initial">{{fullNameInitial}}</span>
          <span style="font-size:small">{{fullName}}</span>
          <span class="dud-logout" title="Logout" (click)="logout()">
            <i class="feather icon-log-out"></i>
          </span>
        </div>
        <ul class="pro-body">
          <li><a href="javascript:" class="dropdown-item" (click)="goToChangePassword()"><i class="feather icon-lock"></i> Change Password</a></li>
          <li><a href="javascript:" class="dropdown-item" (click)="goToRegisterShipCrew()"><i class="feather icon-user-check"></i> Register as Ship Crew</a></li>
        </ul>
      </div>
    </div>
  </li>
</ul>

